
import { defineComponent } from 'vue';
import SexIcon from '@/shared/components/SexIcon.vue';

export default defineComponent({
  name: 'AdListItemParams',
  props: {
    ad: {
      type: Object,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SexIcon,
  },
  computed: {
    landArea(): string {
      if (this.ad.estateType === 200 || this.ad.estateType === 300) {
        return (this.ad.landArea / 100).toLocaleString();
      } else {
        return '';
      }
    },
    isSale(): boolean {
      return this.ad.adType === 1;
    },
    isLease(): boolean {
      return this.ad.adType === 2;
    },
    isRoommate(): boolean {
      return this.ad.adType === 3;
    },
    isFlat(): boolean {
      return this.ad.estateType === 100;
    },
    isHouse(): boolean {
      return this.ad.estateType === 200;
    },
    isLand(): boolean {
      return this.ad.estateType === 300;
    },
    isDeveloperProject(): boolean {
      return this.ad.estateType === 500;
    },
  },
});
